module.exports = __webpack_public_path__ + "static/media/rapa-nui.3fb63e31.svg";